import styled from 'styled-components'

import card1 from 'assets/landing-images/call-to-action-card1.png'
import card2 from 'assets/landing-images/call-to-action-card2.png'
import card3 from 'assets/landing-images/call-to-action-card3.png'

export const Cards = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 55px 13px;
`

const Card = styled.div`
  width: 400px;
  height: 250px;
  margin: 20px 7px;
  padding: 25px;
  box-shadow: 0px 18px 20px rgba(0, 0, 0, 0.14);
  border-radius: 20px;
  background-size: 400px 250px;

  & .call-to-action-card-button {
    height: 48px;
  }
`

export const Title = styled.h3`
  margin: 0px;
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
`

export const Accent1 = styled.span``

export const Accent2 = styled.span``

export const Text = styled.p``

export const Card1 = styled(Card)`
  background-image: url(${card1});

  & ${Title} {
    font-size: 26px;
    line-height: 1;
    margin-bottom: 20px;
  }

  & ${Accent1} {
    display: inline-block;
    padding: 9px 22px 0px;
    background: #42ce61;
    border-radius: 22px;
    font-size: 26px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 7px;
  }

  & ${Accent2} {
    display: inline-block;
    font-size: 18px;
    color: #42ce61;
  }

  & ${Text} {
    font-size: 20px;
  }
`

export const Card2 = styled(Card)`
  background-image: url(${card2});

  & ${Title} {
    font-size: 21px;
  }

  & ${Text} {
    margin: 10px 0px;
    font-size: 15px;
    font-weight: 300;
  }

  & .call-to-action-card-button {
    display: inline-flex;
    vertical-align: middle;
    width: 170px;

    :first-of-type {
      margin-right: 10px;
    }
  }
`

export const Card3 = styled(Card)`
  background-image: url(${card3});
  color: white;

  & ${Title} {
    font-size: 26px;
    line-height: 1;
  }

  & ${Text} {
    margin: 10px 0px;
    font-size: 15px;
    font-weight: 300;
  }

  & .call-to-action-card-button {
    width: 198px;
  }
`
